/**
 * View component for /transitions/:transitionId/update
 *
 * Updates a single transition from a copy of the selcted transition
 * as defined in the transition reducer
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { history, withRouter } from 'react-router-dom';

// import third-party libraries
import _ from 'lodash';

// import actions
import * as transitionActions from '../transitionActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

// import module components
import TransitionForm from '../components/TransitionForm.js.jsx';
import TransitionLayout from '../components/TransitionLayout.js.jsx';

// import transition css modules
import transitionStyles from '../transitionModuleStyles.css';

class UpdateTransition extends Base {
  constructor(props) {
    super(props);
    const { selectedTransition, transitionMap } = this.props;
    this.state = {
      transition: transitionMap[selectedTransition.id] ? { ...transitionMap[selectedTransition.id] } : {}
      // NOTE: we don't want to change the store, just make changes to a copy
    }
    this._bind(
      '_handleFormChange'
      , '_handleFormSubmit'
    );
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    dispatch(transitionActions.fetchSingleIfNeeded(match.params.transitionId))
  }

  componentWillReceiveProps(nextProps) {
    const { selectedTransition, transitionMap } = nextProps;
    this.setState({
      transition: transitionMap[selectedTransition.id] ? { ...transitionMap[selectedTransition.id] } : {}
      //we don't want to actually change the store's transition, just use a copy
    })
  }

  _handleFormChange(e) {
    let newTransitionState = _.update( this.state.transition, e.target.name, function() {
      return e.target.value;
    });
    this.setState({transition :newTransitionState});
  }

  _handleFormSubmit(e) {
    const { dispatch, history } = this.props;
    e.preventDefault();
    dispatch(transitionActions.sendUpdateTransition(this.state.transition)).then((action) => {
      if(action.success) {
        history.push(`/transitions/${action.item._id}`)
      } else {
        // console.log("Response Error:");
        // console.log(action);
        alert("ERROR - Check logs");
      }
    });
  }

  render() {
    const { selectedTransition, transitionMap } = this.props;
    const { transition } = this.state;
    const isEmpty = (!transition || transition._id === null || transition._id === undefined);
    return  (
      <TransitionLayout>
        <div className="flex">
          <section className="section">
            {isEmpty ?
              (selectedTransition.isFetching ? <h2>Loading...</h2> : <h2>Empty.</h2>)
              :
              <TransitionForm
                transition={transition}
                cancelLink={`/transitions/${transition._id}`}
                formTitle="Update Transition"
                formType="update"
                handleFormChange={this._handleFormChange}
                handleFormSubmit={this._handleFormSubmit}
              />
            }
          </section>
        </div>
      </TransitionLayout>
    )
  }
}

UpdateTransition.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    selectedTransition: store.transition.selected
    , transitionMap: store.transition.byId
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(UpdateTransition)
);



// WEBPACK FOOTER //
// modules/transition/views/UpdateTransition.js.jsx